import React from 'react';
import { motion } from 'framer-motion';
import { FiBook } from 'react-icons/fi';
import ScrollHeader from '../components/ScrollHeader';

const UserGuide = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <ScrollHeader title="User Guide" />
        
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-primary-500/10 rounded-full">
              <FiBook className="w-16 h-16 text-primary-500" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Complete User Guide
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-8 max-w-3xl mx-auto">
            Comprehensive user guide for Ana Security. Detailed instructions for all features, best practices, and advanced configuration options.
          </p>
        </div>

        <div className="bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border rounded-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            Complete Documentation
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Getting Started
              </h3>
              <ul className="space-y-2 text-gray-600 dark:text-gray-400">
                <li>• Platform login and setup</li>
                <li>• Dashboard navigation</li>
                <li>• Running your first scans</li>
                <li>• Understanding results</li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Security Modules
              </h3>
              <ul className="space-y-2 text-gray-600 dark:text-gray-400">
                <li>• SCA dependency scanning</li>
                <li>• SAST code analysis</li>
                <li>• DAST runtime testing</li>
                <li>• Secrets detection</li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Automation
              </h3>
              <ul className="space-y-2 text-gray-600 dark:text-gray-400">
                <li>• ANA Actions setup</li>
                <li>• CI/CD integration</li>
                <li>• Automated workflows</li>
                <li>• Custom policies</li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Advanced Features
              </h3>
              <ul className="space-y-2 text-gray-600 dark:text-gray-400">
                <li>• Custom reporting</li>
                <li>• API integration</li>
                <li>• Enterprise features</li>
                <li>• Troubleshooting</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default UserGuide;
